@if (layoutService.nameComponents) {
<span class="alert alert-info">participantsummary.component.html</span>
}

<div class="row mb-5">
  <div class="col p-0">
    <div
      class="pt-4 col-12"
      [appLayout]="layoutService.baseColorSurface"
    >
      <div class="row p-0 mb-3">
        <div class="col mx-4">
          <table class="mb-5">
            <tr>
              <td class="pr-1">
                <app-user-image-and-name-display [participant]="participant"></app-user-image-and-name-display>
              </td>
              <td class="pr-5">
                @if (this.isModerator) {
                <a (click)="this.openReportExternal(participant.id)">
                  <i
                    class="ml-1"
                    style="line-height: 48px;"
                    [ngClass]="{'ri-folder-transfer-line':!this.copied, 
                                'ri-check-line':this.copied}"
                    [appLayout]="layoutService.textColor50"
                  ></i>
                </a>
                }
              </td>
              <td class="pr-5">
                <div class="d-flex">
                  <i
                    class="ri-notification-badge-fill pr-2"
                    style="line-height: 24px"
                    [appLayout]="layoutService.textColor50"
                  ></i>
                  <span style="line-height: 24px">{{ pack.name }}</span>
                </div>
              </td>

              <td style="height: 50px"></td>
            </tr>
          </table>
        </div>
      </div>
      <div class="row pb-2">
        <div class="col text-white mx-4 my-2">
          <h4 i18n="@@ratingLabel">Bewertung</h4>
        </div>
        <div class="col text-white mx-4 my-2 text-right">
          <h4 (click)="showFieber = !showFieber"></h4>
          @if (!showFieber) {
          <div
            class="btn-group switcher"
            role="group"
          >
            <button
              (click)="showFieber = false"
              type="button"
              class="btn btn-secondary"
              [appLayout]="layoutService.activeColor"
            >
              <i class="ri-table-line"></i>
            </button>
            <button
              (click)="showFieber = true"
              type="button"
              class="btn btn-secondary"
              [appLayout]="layoutService.baseColorButtons"
            >
              <i class="ri-line-chart-line"></i>
            </button>
          </div>
          }
          @if (showFieber) {
          <div
            class="btn-group switcher"
            role="group"
          >
            <button
              (click)="showFieber = false"
              type="button"
              class="btn btn-secondary"
              [appLayout]="layoutService.baseColorButtons"
            >
              <i class="ri-table-line"></i>
            </button>
            <button
              (click)="showFieber = true"
              type="button"
              class="btn btn-secondary"
              [appLayout]="layoutService.activeColor"
            >
              <i class="ri-line-chart-line"></i>
            </button>
          </div>
          }
        </div>
      </div>

      <div class="row pb-2">
        <div class="col mx-4 my-2">
          <ng-container *ngTemplateOutlet="fieberkurve"></ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- END TOPPER-->

<div class="row text-left">

  @for (event of this.events; track event) {
  <div class="col-12 px-5">
    <app-summary-timeblock
      [event]="event"
      [mycomments]="mycomments"
    ></app-summary-timeblock>
    <div
      class="mt-5 mx-n5 mb-5"
      style="border-bottom: 1px solid #000"
    ></div>
  </div>
  }

  <div class="row text-left pt-2">
    @if (totalRating && totalRating.strength) {
    <div class="col-6">
      <div class="card mb-2">
        <div
          i18n="@@ratingStrengths"
          class="card-header"
        >Stärken</div>
        <div class="card-body">
          {{ totalRating.strength }}
        </div>
      </div>
    </div>
    }
    @if (totalRating && totalRating.learningArea) {
    <div class="col-6">
      <div class="card mb-2">
        <div
          i18n="@@summaryTotalDevelopmentAreas"
          class="card-header"
        >Entwicklungsfelder</div>
        <div class="card-body">
          {{ totalRating.learningArea }}
        </div>
      </div>
    </div>
    }
    @if (totalRating && totalRating.devmeasures) {
    <div class="col-12">
      <div class="card mb-2">
        <div
          i18n="@@summaryTotalDevMeasures"
          class="card-header"
        >Entwicklungsmaßnahmen</div>
        <div class="card-body">
          {{ totalRating.devmeasures }}
        </div>
      </div>
    </div>
    }
  </div>
</div>

<ng-template #fieberkurve>
  <table
    class="fieberkurve w-100 mb-4"
    #fieberTable
  >
    <tr style="height:52px">
      <td
        [ngStyle]="
        {'width': layoutService.fieberKurveDimensinCellWidth  + 'px',
       'border-left-style': 'none'
      }"
        class="cursor-default"
      ></td>
      <!-- HEADER FÜR TIMEBLOCK -->
      @if (!showFieber) {
      @for (event of this.events; track event) {
      <td
        class="p-3 text-center cursor-default text-break"
        [appLayout]="layoutService.baseColorButtons"
      >
        {{ event.timeblock.name }}
      </td>
      }
      }
      <!-- HEADER FÜR KURVE -->
      @if (this.showFieber) {
      <td
        class="p-3 text-center cursor-default"
        [colSpan]="getScaleForStep1(pack.scale).length"
        [rowSpan]="ratingSummary.dimensions.length+1"
        style="padding: 0px !important; background-color: transparent !important; border-left-style:none;"
        id="canvasContainer"
      >
        <canvas
          id="chartCanvas"
          #thechart
          baseChart
          class="chart"
          [datasets]="getchartData()"
          [options]="getChartconfig()"
          type="line"
          [height]="80+(ratingSummary.dimensions.length) * 40"
          [width]="800"
          style="background-color:#232E55; padding-top: 30px; width: 100%;"
        >
        </canvas>
      </td>
      }
      <td
        i18n="@@summaryTotal"
        [appLayout]="layoutService.baseColorButtons"
        class="p-3 text-center cursor-default text-break"
        [ngStyle]="{'width': layoutService.fieberKurveGesamtCellWidth + 'px'}"
      >
        Gesamt
      </td>
    </tr>
    @for (dimension of ratingSummary.dimensions; track dimension; let i = $index) {
    <tr>
      <td
        class="text-white pl-0 pr-3 py-0"
        [ngStyle]="{
          'border': '1px solid ' + layoutService.baseColorButtons.backgroundColor,
          'width': layoutService.fieberKurveDimensinCellWidth + 'px',
          'border-left-style':'none !important',
          'border-left':'0px'
      }"
        style="border-left: 0px;height: 52px;overflow: hidden; border-left-style:none !important;"
      >
        {{ dimension.name }}
      </td>
      @if (!showFieber) {
      <!-- CONTENT OHNE FIEBER-->
      @for (event of this.events; track event) {
      <td
        class="dimensionTotal pt-3 pb-3 text-center"
        [ngStyle]="{'border': '1px solid ' + layoutService.baseColorButtons.backgroundColor}"
        [ngClass]="{
              disabledcell: !getIsDisabled(event.timeblock._id, dimension)
            }"
      >
        @if (!getIsDisabled(event.timeblock._id, dimension)) {
        <div
          class="striped"
          style="width:50%;margin:0px auto"
        >
          &nbsp;
        </div>
        }
        @if (getScaleValue(event.timeblock._id, dimension.id) != null) {
        <div
          [ngStyle]="{'background-color': layoutService.scoreColors[0].backgroundColor}"
          style="border-radius: 25px; margin:0px auto; width:50%;"
        >
          {{ getScaleValue(event.timeblock._id, dimension.id) }}
        </div>
        }
      </td>
      }
      }
      <!-- FIEBER KURVE CONTENT -->
      <td
        class="dimensionTotal pt-3 pb-3 text-center"
        [ngStyle]="{'border': '1px solid ' + layoutService.baseColorButtons.backgroundColor}"
        style="border-right: 0px"
      >
        @if (getDimensionTotalValue(dimension) !== null) {
        <div
          [ngStyle]="{'background-color': layoutService.scoreColors[0].backgroundColor}"
          style="border-radius: 25px; margin:0px auto; width:50%;"
        >
          {{ getDimensionTotalValue(dimension) | number: '1.1-2' }}
        </div>
        }
      </td>
    </tr>
    }
  </table>
</ng-template>